/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway.scss';

/* eslint-disable import/no-unresolved, import/default */

import gatewayFieldsetTemplate from './gateway-fieldset.tpl.html';
import spectrumAnalyzerDialogTemplate from './spectrum-analyzer/spectrum-analyzer.dialog.tpl.html';
import spectralScanDialogTemplate from './spectral-scan/spectral-scan.dialog.tpl.html';
import radioStatisticsDialogTemplate from './radio-statistics/radio-statistics.dialog.tpl.html';
import gatewayInfoDialogTemplate from './gateway-info/gateway-info.dialog.tpl.html';
import wmFirmwareTemplate from './wm-firmware/wm-firmware.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

const defaultMapZoom = 12;
const dashboardTabIndex = 4;

/*@ngInject*/
export default function GatewayDirective($rootScope, $compile, $templateCache, $translate, $mdUtil, $filter, $mdMedia, $mdDialog, toast, $sce, $window,
                                         $document, types, gatewayService, gatewayStatisticsService, gatewayModelService, gatewayCommandService, grafanaService) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayFieldsetTemplate);
        element.html(template);

        scope.types = types;

        scope.statsQuery = {
            timewindow: {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            },
            order: '-ts',
            limit: 15,
            page: 1,
            search: null
        };

        scope.statsLimitOptions =
            [15, 30, 45];

        scope.$watch(function() { return $mdMedia('gt-md'); }, function(isGtMd) {
            scope.isGtMd = isGtMd;
            if (scope.isGtMd) {
                scope.statsLimitOptions = [15, 30, 45];
            } else {
                scope.statsLimitOptions = null;
            }
        });

        scope.gatewayCommand = {
            command: null,
            params: {},
            commandOutput: ''
        };

        scope.commandOutputOptions = {
            useWrapMode: false,
            mode: 'json',
            showGutter: false,
            showPrintMargin: false,
            theme: 'github',
            advanced: {
                enableSnippets: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false
            }
        };

        scope.endTime = {
            locked: false,
            ms: 0
        };

        scope.lastGatewayStats = {};
        scope.newGatewayStatsCountAfterBlock = 0;

        scope.grafanaEnabled = $window.DynamicConfigs.grafanaEnabled === 'true';
        scope.grafanaIframeUrl = null;
        scope.creatingDashboard = false;

        scope.$watch('gateway.id.id', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (newVal) {
                    reset();
                    getLastReportedLocation();
                    updateGatewayStatsRows();
                    createGatewaySubscriptions();
                    if (scope.grafanaEnabled && scope.selectedTab == dashboardTabIndex) {
                        createGrafanaDashboard();
                    }
                }
            }
        });

        scope.$watch('selectedTab', (newVal, prevVal) => {
            if (newVal !== prevVal && scope.grafanaEnabled && newVal === dashboardTabIndex &&
                scope.gateway.id && !scope.grafanaIframeUrl) {
                createGrafanaDashboard();
            }
        })

        scope.$watch('gateway.gatewayModelId', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                loadGatewayFrequencyInfo();
                refreshFskState();
            }
        });

        scope.$watch('gatewayCommand.command', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                scope.gatewayCommand.params = {};
                scope.gatewayCommand.commandOutput = '';
                if (scope.gatewayCommand.command == types.gatewayCommand.reverseSsh.value) {
                    scope.gatewayCommand.params.options = '-f -N -T -R';
                }
            }
        });

        scope.onGatewayIdCopied = function() {
            toast.showSuccess($translate.instant('gateway.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.openSpectrumAnalyzer = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'SpectrumAnalyzerController',
                controllerAs: 'vm',
                templateUrl: spectrumAnalyzerDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openSpectralScan = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'SpectralScanController',
                controllerAs: 'vm',
                templateUrl: spectralScanDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openRadioStatistics = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'RadioStatisticsController',
                controllerAs: 'vm',
                templateUrl: radioStatisticsDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openGatewayInfo = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'GatewayInfoController',
                controllerAs: 'vm',
                templateUrl: gatewayInfoDialogTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.openWmFirmwareDialog = function($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $mdDialog.show({
                controller: 'WmFirmwareController',
                controllerAs: 'vm',
                templateUrl: wmFirmwareTemplate,
                parent: angular.element($document[0].body),
                locals: {
                    gatewayId: scope.gateway.id
                },
                fullscreen: true,
                skipHide: true,
                targetEvent: $event
            });
        };

        scope.toggleGatewayState = function() {
            var promise = scope.gateway.disabled ? gatewayService.enableGateway(scope.gateway.id.id)
                : gatewayService.disableGateway(scope.gateway.id.id);
            promise.then(
                () => {
                    scope.gateway.disabled = !scope.gateway.disabled;
                    updateGatewayStateParameters();
                    $rootScope.$broadcast('reloadEntityDetails');
                    $rootScope.$broadcast('entityUpdated', scope.gateway);
                }
            );
        };

        scope.$on("form-submit", function () {
            updateGatewayLocation();
        });

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (!angular.equals(newVal, prevVal)) {
                if (scope.isEdit && scope.selectedTab > 1) {
                    scope.selectedTab = 0;
                }
            }
        });

        scope.$on("$destroy", function () {
            reset();
        });

        scope.onGatewayStatisticsPaginate = function () {
            updateGatewayStatsRows();
        };

        scope.blockGatewayStatisticsUpdates = function () {
            blockGatewayStatisticsUpdates();
        };

        scope.releaseGatewayStatisticsUpdates = function () {
            unblockGatewayStatisticsUpdates();
        };

        scope.executeGatewayCommand = function () {
            gatewayCommandService.executeCommand(scope.gateway.id.id,
                scope.gatewayCommand.command, scope.gatewayCommand.params).then(
                    (commandResult) => {
                        if (commandResult) {
                            if (commandResult.output) {
                                scope.gatewayCommand.commandOutput = commandResult.output;
                            } else if (commandResult.error) {
                                if (angular.equals(commandResult.error, types.gatewayCommandNotSupported.value)) {
                                    var toastParent = angular.element(".tk-ace-command-output", $document);
                                    toast.showError($translate.instant("gateway-command.not-supported"), toastParent.closest(".toast-parent"), "bottom right");
                                    scope.gatewayCommand.commandOutput = $translate.instant("gateway-command.not-supported").toString();
                                }
                            } else {
                                scope.gatewayCommand.commandOutput = angular.toJson(commandResult, true)
                            }
                        } else {
                            scope.gatewayCommand.commandOutput = '';
                        }
                    },
                    (rejection) => {
                        scope.gatewayCommand.commandOutput = 'Error executing gateway command.';
                        if (rejection.status) {
                            scope.gatewayCommand.commandOutput += '\nStatus: ' + rejection.status;
                        }
                        if (rejection.data) {
                            scope.gatewayCommand.commandOutput += '\nError: ';
                            if (rejection.data.message) {
                                scope.gatewayCommand.commandOutput += rejection.data.message;
                            } else {
                                scope.gatewayCommand.commandOutput += rejection.data;
                            }
                        }
                    }
            );
        };

        function loadGatewayFrequencyInfo() {
            scope.gatewayFrequencyBandInfo = null;
            if (scope.gateway.gatewayModelId) {
                gatewayModelService.getGatewayModel(scope.gateway.gatewayModelId.id).then(
                    (gatewayModel) => {
                        scope.gatewayFrequencyBandInfo = types.gatewayFrequency[gatewayModel.gatewayFrequency].info;
                        scope.gatewayModelChannels = gatewayModel.additionalInfo ? gatewayModel.additionalInfo.channels : '';
                    }
                );
            }
        }

        function watchStatsTimewindow() {
            scope.statsTimewindowWatch = scope.$watch("statsQuery.timewindow", function(newVal, prevVal) {
                if (newVal && !angular.equals(newVal, prevVal)) {
                    updateGatewayStatsSubscription();
                }
            }, true);
        }

        function stopWatchStatsTimewindow() {
            if (scope.statsTimewindowWatch) {
                scope.statsTimewindowWatch();
                scope.statsTimewindowWatch = null;
            }
        }

        function updateGatewayStateParameters() {
            if (scope.gatewayState.online && !scope.gateway.disabled) {
                scope.onlineStatus = $translate.instant('gateway.online');
                scope.onlineStatusColor = '#1a901a';
            } else {
                scope.onlineStatus = scope.gateway.disabled ? $translate.instant('gateway.disabled') : $translate.instant('gateway.offline');
                scope.onlineStatusColor = '#ff0000';
            }

            if (scope.gatewayState.active && !scope.gateway.disabled) {
                scope.activityStatus = $translate.instant('gateway.active');
                scope.activityStatusColor = '#1a901a';
            } else {
                scope.activityStatus = scope.gateway.disabled ? $translate.instant('gateway.disabled') : $translate.instant('gateway.inactive');
                scope.activityStatusColor = '#ff0000';
            }
        }

        function updateFskGatewayStateParameters() {
            var fskState = scope.fskGatewayState || {};
            if (fskState.online) {
                scope.fskOnlineStatus = $translate.instant('gateway.online');
                scope.fskOnlineStatusColor = '#1a901a';
            } else {
                scope.fskOnlineStatus = $translate.instant('gateway.offline');
                scope.fskOnlineStatusColor = '#ff0000';
            }

            if (fskState.active) {
                scope.fskActivityStatus = $translate.instant('gateway.active');
                scope.fskActivityStatusColor = '#1a901a';
            } else {
                scope.fskActivityStatus = $translate.instant('gateway.inactive');
                scope.fskActivityStatusColor = '#ff0000';
            }
        }

        function unsubscribeGatewayStats() {
            if (scope.gatewayStatsSubscriptionHandle) {
                scope.gatewayStatsSubscriptionHandle();
                scope.gatewayStatsSubscriptionHandle = null;
            }
        }

        function unsubscribeGatewayState() {
            if (scope.gatewayStateSubscriptionHandle) {
                scope.gatewayStateSubscriptionHandle();
                scope.gatewayStateSubscriptionHandle = null;
            }
        }
        function subscribeGatewayStats() {
            scope.gatewayStatsSubscriptionHandle = gatewayService.subscribeForGatewayStatsData(scope.gateway.id.id,
                scope.statsQuery.timewindow, onGatewayStatsData, onGatewayStatsDataReconnected);
        }

        function subscribeGatewayState() {
            scope.gatewayStateSubscriptionHandle = gatewayService.subscribeForGatewayStateData(scope.gateway.id.id,
                onGatewayStateData);
        }

        function unsubscribeGatewayFskState() {
            if (scope.gatewayFskStateSubscriptionHandle) {
                scope.gatewayFskStateSubscriptionHandle();
                scope.gatewayFskStateSubscriptionHandle = null;
            }
        }

        function subscribeGatewayFskState() {
            unsubscribeGatewayFskState();
            scope.gatewayFskStateSubscriptionHandle = gatewayService.subscribeForGatewayFskStateData(scope.gateway.id.id,
                onGatewayFskStateData);
        }

        // Resolve the gateway model to decide whether this is an FSK gateway and, if so, subscribe to its
        // live FSK state. Driven from createGatewaySubscriptions (gateway open) since FSK gateways share the
        // same model id, so a gateway-id change alone must (re)establish the correct FSK subscription.
        function refreshFskState() {
            unsubscribeGatewayFskState();
            scope.isFskGateway = false;
            if (scope.gateway && scope.gateway.id && scope.gateway.gatewayModelId) {
                gatewayModelService.getGatewayModel(scope.gateway.gatewayModelId.id).then(
                    (gatewayModel) => {
                        if (gatewayModel && gatewayModel.fsk) {
                            scope.isFskGateway = true;
                            subscribeGatewayFskState();
                        }
                    }
                );
            }
        }

        function reset() {

            scope.gatewayCommand.command = null;
            scope.gatewayCommand.params = {};
            scope.gatewayCommand.commandOutput = '';
            scope.grafanaIframeUrl = null;

            stopWatchStatsTimewindow();

            scope.gatewayState = {};
            scope.fskGatewayState = {};
            scope.isFskGateway = false;

            scope.gatewayStats = [];
            scope.lastGatewayStats = {};

            unsubscribeGatewayState();
            unsubscribeGatewayFskState();
            unsubscribeGatewayStats();

            scope.endTime.locked = false;
            scope.endTime.ms = 0;

            scope.lastActivityTime = null;
            scope.lastOnlineTime = null;
            scope.lastFskActivityTime = null;
            scope.lastFskOnlineTime = null;

            updateGatewayStateParameters();
            updateFskGatewayStateParameters();

            scope.currentGatewayLat = null;
            scope.currentGatewayLng = null;
            scope.currentGatewayAlt = null;

            scope.currentGatewayCenter = {
                lat: 0,
                lng: 0,
                zoom: 1
            };

            scope.markers = {};

            scope.statsQuery.timewindow = {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            };
            scope.statsQuery.order = '-ts';
            scope.statsQuery.limit = 15;
            scope.statsQuery.page = 1;
            scope.statsQuery.search = null;

            watchStatsTimewindow();
            resetStatsLockingVariables();
        }

        function createGatewaySubscriptions() {
            subscribeGatewayState();
            subscribeGatewayStats();
            refreshFskState();
        }

        function updateGatewayStatsSubscription() {

            unsubscribeGatewayStats();

            scope.gatewayStats = [];

            updateGatewayLocation();
            updateGatewayStatsRowsFromFirstPage();

            if (!scope.statsQuery.timewindow.history.fixedTimewindow) {
                subscribeGatewayStats();
            }
        }

        function onGatewayStateData(gatewayState) {
            scope.$apply(() => {
                scope.gatewayState = gatewayState;
                if (scope.gatewayState.lastOnlineTime) {
                    scope.lastOnlineTime = $filter('date')(scope.gatewayState.lastOnlineTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastOnlineTime = null;
                }
                if (scope.gatewayState.lastActivityTime) {
                    scope.lastActivityTime = $filter('date')(scope.gatewayState.lastActivityTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastActivityTime = null;
                }
                updateGatewayStateParameters();
            });
        }

        function onGatewayFskStateData(fskGatewayState) {
            scope.$apply(() => {
                scope.fskGatewayState = fskGatewayState;
                if (scope.fskGatewayState.lastOnlineTime) {
                    scope.lastFskOnlineTime = $filter('date')(scope.fskGatewayState.lastOnlineTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastFskOnlineTime = null;
                }
                if (scope.fskGatewayState.lastActivityTime) {
                    scope.lastFskActivityTime = $filter('date')(scope.fskGatewayState.lastActivityTime, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    scope.lastFskActivityTime = null;
                }
                updateFskGatewayStateParameters();
            });
        }

        function onGatewayStatsData(gatewayStats) {
            scope.$apply(() => {
                if (scope.endTime.locked === false){
                    if (gatewayStats && gatewayStats.length) {
                        scope.gatewayStats = scope.gatewayStats.concat(gatewayStats);
                    }
                    if (scope.gatewayStats.length) {
                        scope.gatewayStats = $filter('orderBy')(scope.gatewayStats, '-ts');
                        scope.lastGatewayStats = scope.gatewayStats[0];
                    }
                    updateGatewayLocation();
                    updateStats();
                } else {
                    if (gatewayStats && gatewayStats.length) {
                        scope.newGatewayStatsCountAfterBlock = scope.newGatewayStatsCountAfterBlock + gatewayStats.length;
                        var receivedGatewayStats = gatewayStats;
                        receivedGatewayStats = $filter('orderBy')(receivedGatewayStats, '-ts');
                        scope.lastGatewayStats = receivedGatewayStats[0];
                    }
                    updateGatewayLocation();
                }
            });
        }

        function onGatewayStatsDataReconnected() {
            scope.$apply(() => {
                scope.gatewayStats = [];

                updateGatewayLocation();
                updateGatewayStatsRows();
            });
        }

        function blockGatewayStatisticsUpdates() {
            if(!scope.endTime.locked){
                scope.endTime.locked = true;
                scope.endTime.ms = (new Date).getTime();
            }
        }

        function unblockGatewayStatisticsUpdates() {
            if (scope.statsQuery.page === 1){
                resetStatsLockingVariables();
                updateGatewayStatsRows();
            }
        }
        
        function resetStatsLockingVariables() {
            scope.endTime.locked = false;
            scope.newGatewayStatsCountAfterBlock = 0;
        }

        function updateGatewayStatsRowsFromFirstPage() {
            scope.statsQuery.page = 1;
            updateGatewayStatsRows();
        }

        function updateGatewayStatsRows() {

            if (scope.statsQuery.page !== 1) blockGatewayStatisticsUpdates();

            var startTimeMs;
            var endTimeMs;

            if (scope.statsQuery.timewindow.history.timewindowMs) {
                if(scope.endTime.locked){
                    endTimeMs =  scope.endTime.ms;

                } else {
                    endTimeMs =  (new Date).getTime();
                }
                startTimeMs = endTimeMs - scope.statsQuery.timewindow.history.timewindowMs;
            } else {
                startTimeMs = scope.statsQuery.timewindow.history.fixedTimewindow.startTimeMs;
                endTimeMs = scope.statsQuery.timewindow.history.fixedTimewindow.endTimeMs;
            }


            scope.statsPromise = gatewayStatisticsService.getGatewayStatisticsScroll(scope.gateway.mac,
                startTimeMs,
                endTimeMs,
                scope.statsQuery.limit,
                scope.statsQuery.page - 1);

            scope.statsPromise.then(
                (result) => {
                    if (!result.data) {
                        result.data = []
                    }
                    if (result.data.length > 0 || result.page === 0) {
                        scope.gatewayStats = result.data;
                        // This is done to reuse the same table-pagination component for scrolling pagination
                        scope.statsRowsCount = getTotalElements(result);
                        updateStats();
                    } else {
                        revertPageInPaginator();
                    }
                },
                () => {
                    updateStats();
                }
            );
        }

        function revertPageInPaginator() {
            scope.statsQuery.page--;
            scope.statsRowsCount--;
        }

        // This is done to reuse the same table-pagination component for scrolling pagination
        function getTotalElements(result) {
            let totalElements = result.page * result.limit + result.data.length;
            if (result.data.length === result.limit) {
                totalElements++;
            }
            return totalElements;
        }

        function updateStats() {
            scope.gatewayStatsRows =$filter('orderBy')(scope.gatewayStats, scope.statsQuery.order);
            scope.gatewayStatsRows =$filter('limitTo')(scope.gatewayStatsRows, scope.statsQuery.limit);
        }

        function getLastReportedLocation() {
            const limit = 1;
            const startTimeMs = 0;
            const endTimeMs =  (new Date).getTime();
            const page = 0;
            gatewayStatisticsService.getGatewayStatisticsScroll(scope.gateway.mac, startTimeMs, endTimeMs, limit, page).then(
                (result) => {
                    if (result.data && result.data.length > 0) {
                        scope.lastGatewayStats = result.data[0];
                        updateGatewayLocation(); 
                    }
                }, () => {}
            );
        }

        function updateGatewayLocation() {
            var lat = null, lng = null, altitude = null;

            if (angular.isDefined(scope.lastGatewayStats.latitude)
                && scope.lastGatewayStats.latitude != null
                && scope.lastGatewayStats.latitude !== 0) {
                lat = scope.lastGatewayStats.latitude;
            } else if (angular.isDefined(scope.gateway.lat)) {
                lat = scope.gateway.lat;
            }
            if (angular.isDefined(scope.lastGatewayStats.longitude)
                && scope.lastGatewayStats.longitude != null
                && scope.lastGatewayStats.longitude !== 0) {
                lng = scope.lastGatewayStats.longitude;
            } else if (angular.isDefined(scope.gateway.lng)) {
                lng = scope.gateway.lng;
            }
            if (angular.isDefined(scope.lastGatewayStats.altitude)
                && scope.lastGatewayStats.altitude != null
                && scope.lastGatewayStats.altitude !== 0) {
                altitude = scope.lastGatewayStats.altitude;
            } else if (angular.isDefined(scope.gateway.altitude)) {
                altitude = scope.gateway.altitude;
            }
            scope.currentGatewayLat = lat;
            scope.currentGatewayLng = lng;
            scope.currentGatewayAlt = altitude;
            if (scope.currentGatewayLat != null && scope.currentGatewayLng != null) {
                scope.currentGatewayCenter.lat = scope.currentGatewayLat;
                scope.currentGatewayCenter.lng = scope.currentGatewayLng;
                if (!scope.markers.gateway) {
                    scope.currentGatewayCenter.zoom = defaultMapZoom;
                }
                scope.markers.gateway = {
                    lat: scope.currentGatewayLat,
                    lng: scope.currentGatewayLng
                }
            } else {
                scope.currentGatewayCenter.lat = 0;
                scope.currentGatewayCenter.lng = 0;
                scope.currentGatewayCenter.zoom = 1;
                delete scope.markers.gateway;
            }
        }

        function createGrafanaDashboard() {
            scope.creatingDashboard = true;
            grafanaService.createGatewayDashboard(scope.gateway.id.id).then(function (response) {
                scope.creatingDashboard = false;
                if (response && response.accessToken) {
                    const url = 'https://' + $window.DynamicConfigs.appHost + '/grafana/public-dashboards/' + response.accessToken;
                    scope.grafanaIframeUrl = $sce.trustAsResourceUrl(url);
                } else {
                    toast.showError('Failed to create dashboard', 3000);
                }
            }).catch(function () {
                scope.creatingDashboard = false;
                toast.showError('Failed to create dashboard', 3000);
            });
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gateway: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway/gateway.directive.js